import { useMemo } from 'react';

export function useProjectedCashFlows(initialFCF, growthRate, discountRate) {
    return useMemo(() => {
        const years = 20;
        const projectedCashFlows = [];
        let sumDiscountedFCF = 0;

        for (let year = 1; year <= years; year++) {
            const futureFCF = initialFCF * Math.pow(1 + growthRate / 100, year);
            const discountedFCF = futureFCF / Math.pow(1 + discountRate / 100, year);

            sumDiscountedFCF += discountedFCF;

            projectedCashFlows.push({
                year,
                futureFCF: futureFCF.toFixed(2),
                discountedFCF: discountedFCF.toFixed(2),
            });
        }

        return { cashFlows: projectedCashFlows, totalValue: sumDiscountedFCF };
    }, [initialFCF, discountRate, growthRate]);
}
